import React, { useState } from 'react';
import { Box } from '@chakra-ui/react';
import CustomValidationControl from './CustomValidationControl';

export type ScheduleType = 'daily' | 'weekly' | 'monthly' | 'yearly';
interface Props {
    name: string;
    type: ScheduleType;
    defaultValue?: Date;
    onDateChange: (selectedDate: Date) => void;
    [x: string]: any;
}

const Months = [
    { value: '0', label: 'January' },
    { value: '1', label: 'February' },
    { value: '2', label: 'March' },
    { value: '3', label: 'April' },
    { value: '4', label: 'May' },
    { value: '5', label: 'June' },
    { value: '6', label: 'July' },
    { value: '7', label: 'August' },
    { value: '8', label: 'September' },
    { value: '9', label: 'October' },
    { value: '10', label: 'November' },
    { value: '11', label: 'December' },
];

const DaysOfWeek = [
    { value: 'sunday', label: 'Sunday' },
    { value: 'monday', label: 'Monday' },
    { value: 'tuesday', label: 'Tuesday' },
    { value: 'wednesday', label: 'Wednesday' },
    { value: 'thursday', label: 'Thursday' },
    { value: 'friday', label: 'Friday' },
    { value: 'saturday', label: 'Saturday' },
];

const DateScheduler: React.FC<Props> = ({ name, type, defaultValue, onDateChange }) => {
    const [selectedTime, setSelectedTime] = useState<Date>(defaultValue ?? new Date());
    const [dayOfWeek, setDayOfWeek] = useState(defaultValue?.getDay().toString());
    const [dayOfMonth, setDayOfMonth] = useState(defaultValue?.getDate());
    const [month, setMonth] = useState(defaultValue?.getMonth().toString());

    const [selectedDate, setSelectedDate] = useState<Date>(defaultValue ?? new Date());

    const getNextDayOfWeek = (dayOfWeek: string): Date => {
        const daysOfWeek = [
            'sunday',
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday',
        ];
        const today = new Date(selectedDate);
        const target = daysOfWeek.indexOf(dayOfWeek.toLowerCase());
        const todayNum = today.getDay();
        const delta = target < todayNum ? target + 7 - todayNum : target - todayNum;
        const nextDate = new Date(today);
        nextDate.setDate(today.getDate() + delta);
        return nextDate;
    };

    const handleTimeChange = (date: Date) => {
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const newDate = new Date(selectedDate);
        newDate.setHours(hours);
        newDate.setMinutes(minutes);
        setSelectedTime(newDate);
        setSelectedDate(newDate);
        onDateChange(newDate);
    };

    const handleDayOfMonth = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const dayof = parseInt(event.target.value);
        const newDate = new Date(selectedDate);
        newDate.setDate(dayof);
        setDayOfMonth(dayof);
        setSelectedDate(newDate);
        onDateChange(newDate);
    };

    const handleDayOfWeek = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newDate = getNextDayOfWeek(event.target.value);
        setDayOfWeek(event.target.value);
        setSelectedDate(newDate);
        onDateChange(newDate);
    };
    const handleMonthChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newMonth = event.target.value;
        const newDate = new Date(selectedDate);
        newDate.setMonth(parseInt(newMonth));
        setMonth(newMonth);
        setSelectedDate(newDate);
        onDateChange(newDate);
    };

    return (
        <Box>
            {type === 'daily' && (
                <CustomValidationControl
                    name={'time'}
                    type="time"
                    value={selectedTime}
                    onDateChange={handleTimeChange}
                    onChange={() => {}}
                    label={'Daily At'}
                ></CustomValidationControl>
            )}
            {type === 'weekly' && (
                <Box>
                    <CustomValidationControl
                        type="select"
                        name="dayOfWeek"
                        value={dayOfWeek}
                        onChange={(event) => handleDayOfWeek(event)}
                        label="Weekly On"
                        options={DaysOfWeek}
                    ></CustomValidationControl>

                    <CustomValidationControl
                        name={'time'}
                        type="time"
                        value={selectedTime}
                        onDateChange={handleTimeChange}
                        label="at"
                        onChange={() => {}}
                    ></CustomValidationControl>
                </Box>
            )}

            {type === 'monthly' && (
                <Box>
                    <CustomValidationControl
                        type="select"
                        onChange={handleDayOfMonth}
                        name="dayOfMonth"
                        value={dayOfMonth}
                        options={Array.from({ length: 28 }, (_, index) => index + 1).map((day) => ({
                            value: day.toString(),
                            label: day.toString(),
                        }))}
                        label="Monthly on the"
                    ></CustomValidationControl>

                    <CustomValidationControl
                        name={'time'}
                        type="time"
                        value={selectedTime}
                        onDateChange={handleTimeChange}
                        label="at"
                        onChange={() => {}}
                    ></CustomValidationControl>
                </Box>
            )}

            {type === 'yearly' && (
                <Box>
                    <CustomValidationControl
                        type="select"
                        name="type"
                        value={month}
                        onChange={handleMonthChange}
                        options={Months}
                        label={'Yearly on'}
                        data-group={type}
                    ></CustomValidationControl>
                    <CustomValidationControl
                        type="select"
                        onChange={handleDayOfMonth}
                        name="dayOfMonth"
                        value={dayOfMonth}
                        options={Array.from({ length: 28 }, (_, index) => index + 1).map((day) => ({
                            value: day.toString(),
                            label: day.toString(),
                        }))}
                        label="on the"
                    ></CustomValidationControl>
                    <CustomValidationControl
                        name={`timeframe.yearly.time`}
                        type="time"
                        value={selectedTime}
                        onDateChange={handleTimeChange}
                        onChange={() => {}}
                        label={'at'}
                        data-group={type}
                    ></CustomValidationControl>
                </Box>
            )}
        </Box>
    );
};

export default DateScheduler;
